import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout'; // Includes Header and Footer

const ConfirmationPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const bookingDetails = location.state || {};

    // Extract query parameters from URL if state is missing
    const searchParams = new URLSearchParams(location.search);
    const bookingId = bookingDetails.bookingId || searchParams.get('bookingId');
    const carId = bookingDetails.carDetails?.id || searchParams.get('carId');

    useEffect(() => {
        if (!bookingDetails.bookingId && bookingId) {
            // Fetch booking details if not provided
            fetch(`https://api.karrentals.ca/get-booking/${bookingId}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        // Merge fetched data into bookingDetails
                        bookingDetails.bookingId = data.bookingId;
                        bookingDetails.carDetails = { id: data.car_id };
                        bookingDetails.customer_name = data.customer_name;
                        bookingDetails.start_date = data.start_date;
                        bookingDetails.end_date = data.end_date;
                        bookingDetails.total_price = data.total_price;
                    }
                })
                .catch((err) => console.error("Error fetching booking details:", err));
        }
    }, [bookingId, bookingDetails]);    

    if (!bookingId) {
        return (
            <Layout>
                <div className="container mx-auto mt-10 px-4">
                    <h2 className="text-2xl font-bold text-center text-red-500">Booking Not Found</h2>
                    <p className="text-center mt-4 text-gray-600">
                        It seems like your booking details are missing. Please try again.
                    </p>
                    <div className="text-center mt-6">
                        <button
                            onClick={() => navigate('/')}
                            className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </Layout>
        );
    }

    const {
        customer_name = searchParams.get('customer_name') || 'Customer',
        start_date = searchParams.get('start_date') || 'N/A',
        end_date = searchParams.get('end_date') || 'N/A',
        total_price = searchParams.get('total_price') || 'N/A',
    } = bookingDetails;

    return (
        <Layout>
            <div className="container mx-auto mt-10 p-4 sm:p-6 bg-white rounded-lg shadow-lg">
                <h2 className="text-2xl sm:text-3xl font-bold text-center text-green-600 mb-4">Booking Confirmed!</h2>
                <p className="text-center text-base sm:text-lg text-gray-700 leading-relaxed">
                    Thank you for your booking, <span className="font-semibold">{customer_name}</span>! Your booking has been confirmed.
                    An email with the details has been sent to you.
                </p>
                <div className="mt-6 flex flex-col sm:flex-row justify-center items-center gap-4">
                    <button
                        onClick={() => navigate('/')}
                        className="w-full sm:w-auto px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded"
                    >
                        Back to Home
                    </button>
                    <button
                        onClick={() => navigate('/managebooking')}
                        className="w-full sm:w-auto px-6 py-2 bg-black text-white rounded"
                    >
                        Go to Manage Booking
                    </button>
                </div>
            </div>
        </Layout>
    );
};

export default ConfirmationPage;
